import { STATUS, OP } from "../../constant";

const INITIAL_STATE = {
    loginStatus: STATUS.DEFAULT,
    loginResult: null,
    loginErrorMessage: '',

    otpStatus: STATUS.DEFAULT,
    otpResult: null,
    otpErrorMessage: '',

    forgetPasswordResult: null,
    forgetPasswordStatus: STATUS.DEFAULT,
    forgetPasswordErrorMessage: '',

    changePasswordResult: null,
    changePasswordStatus: STATUS.DEFAULT,
    changePasswordErrorMessage: '',

    dashboardStatus: STATUS.DEFAULT,
    dashboardResult: null,
    dashboardErrorMessage: '',

    transactionsStatus: STATUS.DEFAULT,
    transactionsResult: null,
    transactionsErrorMessage: '',

    notificationStatus: STATUS.DEFAULT,
    notificationResult: null,
    notificationErrorMessage: '',

    logsStatus: STATUS.DEFAULT,
    logsResult: null,
    logsErrorMessage: ''
}

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        // ------> login reducers
        case OP.LOGIN_LOADING:
            return {
                ...state,
                loginStatus: STATUS.LOADING,
            }
        case OP.LOGIN_SUCCESS:
            return {
                ...state,
                loginStatus: STATUS.SUCCESS,
                loginResult: payload,
                loginErrorMessage: ''
            }
        case OP.LOGIN_FAILURE:
            return {
                ...state,
                loginStatus: STATUS.ERROR,
                loginResult: null,
                loginErrorMessage: payload,
            }
        case OP.LOGIN_RESET:
            return {
                ...state,
                loginStatus: STATUS.DEFAULT,
                loginResult: null,
                loginErrorMessage: ''
            }

        case OP.OTP_LOADING:
            return {
                ...state,
                otpStatus: STATUS.LOADING
            }

        case OP.OTP_SUCCESS:
            return {
                ...state,
                otpStatus: STATUS.SUCCESS,
                otpResult: payload,
                otpErrorMessage: ''
            }

        case OP.OTP_FAILURE:
            return {
                ...state,
                otpStatus: STATUS.ERROR,
                otpResult: null,
                otpErrorMessage: payload
            }

        case OP.OTP_RESET:
            return {
                ...state,
                otpStatus: STATUS.DEFAULT,
                otpResult: null,
                otpErrorMessage: ''
            }

        // -------> forget password reducers
        case OP.FORGET_PASSWORD_LOADING:
            return {
                ...state,
                forgetPasswordStatus: STATUS.LOADING,
            }
        case OP.FORGET_PASSWORD_SUCCESS:
            return {
                ...state,
                forgetPasswordResult: payload,
                forgetPasswordStatus: STATUS.SUCCESS,
                forgetPasswordErrorMessage: ''
            }
        case OP.FORGET_PASSWORD_FAILURE:
            return {
                ...state,
                forgetPasswordResult: null,
                forgetPasswordStatus: STATUS.ERROR,
                forgetPasswordErrorMessage: payload
            }
        case OP.FORGET_PASSWORD_RESET:
            return {
                ...state,
                forgetPasswordResult: null,
                forgetPasswordStatus: STATUS.DEFAULT,
                forgetPasswordErrorMessage: ''
            }

        // -------> change password reducers
        case OP.CHANGE_PASSWORD_LOADING:
            return {
                ...state,
                changePasswordStatus: STATUS.LOADING,
            }
        case OP.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                changePasswordResult: payload,
                changePasswordStatus: STATUS.SUCCESS,
                changePasswordErrorMessage: ''
            }
        case OP.CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                changePasswordResult: null,
                changePasswordStatus: STATUS.ERROR,
                changePasswordErrorMessage: payload
            }
        case OP.CHANGE_PASSWORD_RESET:
            return {
                ...state,
                changePasswordResult: null,
                changePasswordStatus: STATUS.DEFAULT,
                changePasswordErrorMessage: ''
            }


        // -------> dashboard reducers
        case OP.DASHBOARD_LOADING:
            return {
                ...state,
                dashboardStatus: STATUS.LOADING
            }
        case OP.DASHBOARD_SUCCESS:
            return {
                ...state,
                dashboardStatus: STATUS.SUCCESS,
                dashboardResult: payload,
                dashboardErrorMessage: ''
            }
        case OP.DASHBOARD_FAILURE:
            return {
                ...state,
                dashboardStatus: STATUS.ERROR,
                dashboardResult: null,
                dashboardErrorMessage: payload
            }
        case OP.DASHBOARD_RESET:
            return {
                ...state,
                dashboardStatus: STATUS.DEFAULT,
                dashboardResult: null,
                dashboardErrorMessage: ''
            }


        // -------- > transactions reducers
        case OP.TRANSACTIONS_LOADING:
            return {
                ...state,
                transactionsStatus: STATUS.LOADING
            }

        case OP.TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactionsStatus: STATUS.SUCCESS,
                transactionsResult: payload,
                transactionsErrorMessage: ''
            }

        case OP.TRANSACTIONS_FAILURE:
            return {
                ...state,
                transactionsStatus: STATUS.ERROR,
                transactionsResult: null,
                transactionsErrorMessage: payload
            }

        case OP.TRANSACTIONS_RESET:
            return {
                ...state,
                transactionsStatus: STATUS.DEFAULT,
                transactionsResult: null,
                transactionsErrorMessage: ''
            }

        // -------- > notifications reducers
        case OP.NOTIFICATIONS_LOADING:
            return {
                ...state,
                notificationStatus: STATUS.LOADING
            }
        case OP.NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notificationStatus: STATUS.SUCCESS,
                notificationResult: payload,
                notificationErrorMessage: ''
            }
        case OP.NOTIFICATIONS_FAILURE:
            return {
                ...state,
                notificationStatus: STATUS.ERROR,
                notificationResult: null,
                notificationErrorMessage: payload
            }
        case OP.NOTIFICATIONS_RESET:
            return {
                ...state,
                notificationStatus: STATUS.DEFAULT,
                notificationResult: null,
                notificationErrorMessage: ''
            }


        // -------- > logs reducers
        case OP.LOGS_LOADING:
            return {
                ...state,
                logsStatus: STATUS.LOADING
            }
        case OP.LOGS_SUCCESS:
            return {
                ...state,
                logsStatus: STATUS.SUCCESS,
                logsResult: payload,
                logsErrorMessage: ''
            }
        case OP.LOGS_FAILURE:
            return {
                ...state,
                logsStatus: STATUS.ERROR,
                logsResult: null,
                logsErrorMessage: payload
            }
        case OP.LOGS_RESET:
            return {
                ...state,
                logsStatus: STATUS.DEFAULT,
                logsResult: null,
                logsErrorMessage: ''
            }


        default:
            return state;
    }
}